import React, { useState, useEffect, useContext, useRef } from 'react';
import UserSocialCell from '../components/UserSocialCell';
import { AuthContext } from '../context/AuthContext';
import { getHighlyActivePlayers } from '../api/userApi';
import '../Style/ActivityPage.css';
import { useGoalActions } from '../hooks/useGoalActions';
import '../Style/goalCard.css';
import '../Style/privacyManager.css';

const ActivityPage = () => {
  const { currentUser } = useContext(AuthContext);
  const [view, setView] = useState('global');
  const [displayUsers, setDisplayUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [viewedMonths, setViewedMonths] = useState({});
  const loadingGoalLock = useRef({});

  const { handleMonthNav, handleTogglePrivacy } = useGoalActions({
    setGoals: setDisplayUsers,
    setViewedMonths,
    loadingGoalLock,
    setShowModal: () => {},
    setModalTitle: () => {},
    setUserList: () => {},
  });

  useEffect(() => {
    const fetchFeed = async () => {
      if (!currentUser?.id) return;
      try {
        setLoading(true);
        const userTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const data = await getHighlyActivePlayers(view, currentUser.id, userTz);
        console.log('FEED DATA:', data); // <--- ADD THIS
        setDisplayUsers(data);
      } catch (err) {
        console.error('Feed error:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchFeed();
  }, [view, currentUser?.id]);

  const renderFeed = () => {
    // 1. If there's no data, show the empty message
    if (!displayUsers || displayUsers.length === 0) {
      return (
        <div className="empty-feed-message">
          {view === 'following'
            ? 'Nobody you follow has hit the threshold today.'
            : 'No activity found for today yet.'}
        </div>
      );
    }

    // 2. Sort to keep YOU at the top (The DB handled the rest of the filtering/sorting)
    const sortedList = [...displayUsers].sort((a, b) => {
      if (a.id === currentUser?.id) return -1;
      if (b.id === currentUser?.id) return 1;
      return 0;
    });

    // 3. Return the actual list of cells
    return sortedList.map((user) => (
      <UserSocialCell
        key={user.id}
        user={user}
        viewedMonth={viewedMonths[user.id]}
        onMonthNav={handleMonthNav}
        view={view}
      />
    ));
  };

  return (
    <div className="activity-container">
      <header className="activity-header">
        <h1>Activity Feed</h1>

        <div className="toggle-container">
          <button
            onClick={() => setView('global')}
            className={`toggle-btn ${view === 'global' ? 'active' : ''}`}
          >
            Global
          </button>
          <button
            onClick={() => setView('following')}
            className={`toggle-btn ${view === 'following' ? 'active' : ''}`}
          >
            Following
          </button>
        </div>
      </header>

      {loading ? (
        <div className="loading-text">Loading your feed...</div>
      ) : (
        <div className="feed-list">{renderFeed()}</div>
      )}
    </div>
  );
};

export default ActivityPage;
